exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "@media only screen and (min-width: 760px) {\n  a.desktop_footer_phone {\n    pointer-events: none;\n    text-decoration: none; } }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/lib/loader.js!./src/components/atomic/organisms/Footer/footer.scss
// module id = 194
// module chunks = 3